
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class IndexConstituentRorDialog extends SiteEntityDialog<IndexConstituentRorRow, any> {
        protected getFormKey() { return IndexConstituentRorForm.formKey; }
        protected getIdProperty() { return IndexConstituentRorRow.idProperty; }
        protected getLocalTextPrefix() { return IndexConstituentRorRow.localTextPrefix; }
        protected getService() { return IndexConstituentRorService.baseUrl; }
        protected getDeletePermission() { return IndexConstituentRorRow.deletePermission; }
        protected getInsertPermission() { return IndexConstituentRorRow.insertPermission; }
        protected getUpdatePermission() { return IndexConstituentRorRow.updatePermission; }

        protected form = new IndexConstituentRorForm(this.idPrefix);

    }
}